import Column from "./default"
import checkOnPng from "../../../img/CheckOn.png"
import checkOffPng from "../../../img/CheckOff.png"
import {
	addCopyAndPasteEventToElement
} from "./utils"

const checkOnImg = new Image()
const checkOffImg = new Image()
checkOnImg.src = checkOnPng
checkOffImg.src = checkOffPng
export default class CheckboxColumn extends Column {
	get cursor () {
		return "pointer"
	}

	constructor ({ options }) {
		super({ options })
	}

	onCellEdit (ctx, setValue, notifyCellEditEnd) {
		let value = !!ctx.currentCellInfo.value
		const clickTarget = document.createElement("div")
		clickTarget.setAttribute("tabindex", 0)
		clickTarget.style.position = "absolute"
		clickTarget.style.top = "0px"
		clickTarget.style.left = "0px"
		clickTarget.style.bottom = "0px"
		clickTarget.style.right = "0px"
		clickTarget.style.outline = "none"
		clickTarget.addEventListener("click", e => {
			e.stopPropagation()
			value = !value
			setValue(value)
			notifyCellEditEnd()
		})

		clickTarget.addEventListener("keydown", e => {
			if (Column.INPUT_END_KEYS.includes(e.key)) {
				this.onCellEditEnd(ctx)
			} else if (e.key === " ") {
				e.preventDefault()
				value = !value
				setValue(value)
				notifyCellEditEnd()
			}
		})
		addCopyAndPasteEventToElement(clickTarget)
		clickTarget.addEventListener("blur", e => {
			// ここでフォーカスすると、２つ以上グリッドがあった場合にフォーカスの奪い合いになり動作しなくなる
			this.onCellEditEnd(ctx, false)
		})

		ctx.inputEl.appendChild(clickTarget)
		setTimeout(() => {
			clickTarget.focus()
		})
	}

	renderCell (ctx, {
		offsetTop,
		offsetLeft,
		height,
		value,
		isCurrentCell,
		cellInfo
	}) {
		ctx.useContext2d(ctx2d => {
			// セル描画
			const {
				borderColor,
				borderLineWidth,
				bgColor,
				selectBgColor
			} = ctx.gridStyle
			// セル描画
			ctx2d.strokeStyle = borderColor
			ctx2d.lineWidth = borderLineWidth
			ctx2d.fillStyle = bgColor
			if (cellInfo) {
				ctx2d.fillStyle = cellInfo.bgColor || ctx2d.fillStyle
			}
			if (isCurrentCell) {
				ctx2d.fillStyle = selectBgColor
			}
			ctx.fillRect(offsetLeft, offsetTop, this.actualWidth, height)
			ctx.strokeRect(offsetLeft, offsetTop, this.actualWidth, height)

			// チェックボックス
			const img = value ? checkOnImg : checkOffImg
			// const paddingLeft = (this.actualWidth - ctx.fontSize) / 2
			// const paddingTop = (height - ctx.fontSize) / 2
			const paddingLeft = (this.actualWidth - 10) / 2
			const paddingTop = (height - 10) / 2
			// ctx.drawImage(img, offsetLeft + paddingLeft, offsetTop + paddingTop, ctx.fontSize, ctx.fontSize)
			ctx.drawImage(img, offsetLeft + paddingLeft, offsetTop + paddingTop, 10, 10)
		})
	}
}
